export default "__VITE_ASSET__DlLcQNID__"